<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 10:22:19
 * @LastEditTime: 2020-06-14 10:58:08
 * @Description: 解析
 -->
<template>
  <div class="question-resolve">
    <div class="title">
      <p>
        <span>解析</span>
        <span v-if="!resolve" class="tip">无答案解析</span>
      </p>
      <i-button
        :type="btnType"
        @click="canEditOrSaveQuestionResolveHandler">{{ btnText }}</i-button>
    </div>
    <i-input
      ref="resolve-input"
      :value="resolve"
      :readonly="readonly"
      type="textarea"
      placeholder="输入答案解析"
      :rows="5" @on-change="resolveInputChangedHandler" />
  </div>
</template>

<script>
export default {
  name: 'QuestionResolve',
  props: {
    libraryId: { type: String, required: true },
    resolve: { type: String, required: true },
  },
  data() {
    return {
      tempResolve: '',
      readonly: true,
      btnText: '修改',
      btnType: 'primary',
    };
  },
  watch: {
    resolve: {
      immediate: true,
      handler(resolve) {
        this.tempResolve = resolve;
      },
    },
  },
  methods: {
    /**
     * 启用修改或者保存题目解析内容信息
     */
    canEditOrSaveQuestionResolveHandler() {
      if (this.readonly) {
        this.readonly = false;
        this.btnText = '保存';
        this.btnType = 'success';

        (this.$refs['resolve-input']).focus();
      } else {
        this.saveQuestionResolveHandler();
      }

      this.$emit('set-resolve-edit-flag', !this.readonly);
    },
    /**
     * 保存题目解析内容处理函数
     */
    saveQuestionResolveHandler() {
      if (this.tempResolve === this.resolve) {
        this.readonly = true;
        this.btnText = '修改';
        this.btnType = 'primary';

        return;
      }

      this.requestSaveResolveAndSetting();
    },
    /**
     * 题干输入框内容修改
     */
    resolveInputChangedHandler(e) {
      this.tempResolve = e.target.value;
    },
    /**
     * 请求保存题库题目解析并设置
     */
    requestSaveResolveAndSetting() {
      this.requestSaveResolve()
        .then(() => {
          alert('解析内容保存成功');

          this.readonly = true;
          this.btnText = '修改';
          this.btnType = 'primary';

          this.$emit('set-resolve', this.tempResolve);
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求保存题库题目题干信息
     */
    requestSaveResolve() {
      const params = {
        id: this.libraryId,
        tip: this.tempResolve,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.examcenter.librarySaveQuestion(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.question-resolve {
  width: 100%;

  > .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    font-size: 16px;
    font-weight: bold;

    > p > .tip {
      margin-left: 6px;
      color: red;
      font-size: 12px;
    }
  }
}
</style>
